import React, { useCallback } from 'react'
import { Trans } from '@lingui/macro'
import { map } from 'lodash-es'
import { observer, useLocalStore } from 'mobx-react-lite'
import { css } from 'styled-components'
import Router from 'next/router'
import { _, i18n } from '../../utils/intl'
import {
  Grid,
  GridCol,
  Card,
  CardContent,
  CardBg,
  ButtonLayout,
  ButtonPrimary,
  Select,
} from '../../ui-kit'
import { PlacesAutocompleteInput } from '../acceptation-places/PlacesAutocompleteInput'
import { useScript } from '../../utils/hooks/useScript'
import { AcceptationPlacesPageQuery } from '../acceptation-places/StoreAcceptationPlacesPage'
import { storeMergedProducts } from '../../StoreProducts'

const AcceptationPlaces = observer((props: { isClient?: boolean }) => {
  const state = useLocalStore(() => {
    return {
      selectedProductId: 'all',
      selectedPlaceId: '',
      get options() {
        const _options = map(storeMergedProducts.apiProducts, p => ({
          text: p.title,
          value: String(p.id),
        }))

        _options.unshift({
          text: i18n.t`Vyberte produkt`,
          value: 'all',
        })

        return _options
      },
    }
  })

  const onPlaceSelected = useCallback(
    (place?: google.maps.places.PlaceResult | google.maps.GeocoderResult) => {
      if (!place) state.selectedPlaceId = ''
      else state.selectedPlaceId = place.place_id!
      // state.selectedPlaceName = place.formatted_address!
    },
    [state]
  )

  const onCurrentPosition = useCallback(
    (place?: google.maps.GeocoderResult) => {
      if (!place) return
      state.selectedPlaceId = place.place_id
      // state.selectedPlaceName = place.formatted_address!
    },
    [state]
  )

  const [mapsLoaded] = useScript(
    'https://maps.googleapis.com/maps/api/js?key=AIzaSyAI-RRvLTgSe4LlpU08oU8h_x-yZvUey1A&libraries=places&language=sk&region=Sk'
  )

  return (
    <Card>
      <CardBg url="/static/illustrations/pin.svg" className="acceptation-places-widget" />
      <CardContent size="space" style={{ width: '790px', maxWidth: '100%' }}>
        <Grid gutters="condensed">
          <GridCol>
            <div className="mb-tiny" />
            <h2 className="h3 mb-large">
              <Trans>Objavte akceptačné miesta vo vašom okolí</Trans>
            </h2>
          </GridCol>

          <GridCol size={{ m: 4 }}>
            <Select
              size="large"
              className="mb"
              id="search-product"
              value={state.selectedProductId}
              options={state.options}
              css={css`
                .choices__list--single {
                  line-height: 2rem;
                  padding-left: 8px;
                }
              `}
              onChange={id => {
                state.selectedProductId = id
              }}
            />
          </GridCol>
          <GridCol size={{ m: 'fill' }}>
            {mapsLoaded && (
              <PlacesAutocompleteInput
                size="large"
                onPlaceSelected={onPlaceSelected}
                onCurrentPosition={onCurrentPosition}
              />
            )}
          </GridCol>
          <GridCol size={{ m: 'auto' }}>
            <ButtonLayout>
              <ButtonPrimary
                size="large"
                isDisabled={!state.selectedPlaceId}
                onClick={() => {
                  const query: AcceptationPlacesPageQuery = {}

                  // if (state.selectedPlaceName !== '') query.placeName = state.selectedPlaceName
                  if (state.selectedPlaceId !== '') query.placeId = state.selectedPlaceId
                  if (state.selectedProductId !== 'all') query.product = state.selectedProductId

                  Router.push({
                    pathname: `${Router.pathname}${
                      props.isClient ? '/dejeuner' : ''
                    }/acceptation-places`,
                    query,
                  })
                }}>
                <Trans>Hľadať</Trans>
              </ButtonPrimary>
            </ButtonLayout>
          </GridCol>
        </Grid>
      </CardContent>
    </Card>
  )
})

export { AcceptationPlaces }
